import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import {
  getDateToday,
  pembilang,
  formatRP,
} from "../../../../Utils/externalFunctions";

const styles = StyleSheet.create({
  body: { color: "black", margin: 30, fontSize: 8 },
  column: {
    flexDirection: "column",
  },
  row: {
    flexDirection: "row",
  },
  table: {
    display: "table",
    marginTop: 15,
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableBorderBottom: {
    display: "table",
    marginTop: 10,
    paddingBottom: 10,
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColNoBorder: {
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
  },
});

const MyDocument = ({
  formUMO,
  anggaranTransaksi,
  unitKerjaList,
  anggaranDipakaiTransaksi,
}) => {
  const getPimpimpinan = () => {
    const pimpinan = unitKerjaList.find(
      (unit) => unit.nama_unit_kerja === formUMO.id_unit_kerja
    );
    return pimpinan?.nama_kepala || "loading";
  };
  const getyear = (tanggal) => {
    if (tanggal !== undefined) {
      return tanggal.slice(0, 4);
    }
    return tanggal;
  };

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.column}>
        <View style={styles.body}>
          <Text
            style={{
              textAlign: "center",
              fontSize: 14,
              marginTop: 20,
            }}
          >
            BUKTI PENGELUARAN UANG MUKA
          </Text>
          <Text
            style={{
              textAlign: "center",
              fontSize: 14,
              marginBottom: 20,
            }}
          >
            KAS OPERASIONAL (UMKO)
          </Text>
          <View style={{ width: "auto" }}>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>NOMOR</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>
                  /UMKO/Fasilkom/X/{getyear(formUMO.untuk_tanggal)}
                </Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "4.6%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "30.4%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>FAKULTAS/PA/PS</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>Fakultas Ilmu Komputer</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>DPSJ</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>{formUMO.id_unit_kerja}</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>NAMA PENERIMA</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>{formUMO.diajukan_oleh}</Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>JUMLAH</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}>
                  Rp. {formatRP(formUMO.nilai)}
                </Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "30%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>KEPERLUAN</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "80%" }]}>
                <Text style={{ marginTop: 5 }}>{formUMO.keterangan}</Text>
              </View>
              <View style={[styles.row, { width: "0%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "0%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
              <View style={[styles.row, { width: "0%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
          </View>

          <View style={styles.tablenoborder}>
            <View style={[styles.tableRow, { marginTop: 30 }]}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "25%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>Tanggal, </Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text>Mengetahui</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>Penerima,</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
            <View style={[styles.tableRow, { marginTop: 50 }]}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text>{getPimpimpinan()}</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>{formUMO.diajukan_oleh}</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument;
